import React from 'react';
import PropTypes from 'prop-types';
import { Input, Select, Checkbox } from 'components/ui';
import * as Styled from './General.styles';
import { getVatExtemptions } from 'utility/vat';

export const General = ({ form }) => {
  const { values, errors, setFieldValue, setFieldError, setValues } = form;

  const onPlatnikVatChanged = (checked) => {
    setFieldValue('platnikVAT', checked);
    if(checked) {
      setFieldValue('podstawa', "BRAK_ZWOLNIENIA");
      setFieldValue('podstawaInna', "");
    }
  }

  return (
    <Styled.Wrapper>
      <Checkbox
        label="Płatnik VAT"
        checked={values.platnikVAT}
        onChange={(checked) => onPlatnikVatChanged(checked)}
      />
      <Select
        onChange={(value) => setFieldValue('podstawa', value)}
        value={values.podstawa}
        label="Podstawa zwolnienia*"
        error={errors.podstawa}
        options={getVatExtemptions()}
        disabled={values.platnikVAT}
      />
      <Input
        onChange={(value) => setFieldValue('podstawaInna', value)}
        value={values.podstawaInna}
        label="Inna podstawa lub rozporządzenie"
        error={errors.podstawaInna}
        className="smallInput"
        disabled={values.platnikVAT}
      />
    </Styled.Wrapper>
  );
};

General.propTypes = {
  form: PropTypes.object.isRequired,
  setToastData: PropTypes.func.isRequired,
  isNipDisabled: PropTypes.bool.isRequired,
};
